module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"2026 makeNTU: HEPHAESTUS","short_name":"makeNTU","start_url":"/","background_color":"#6C63FF","theme_color":"#6C63FF","display":"minimal-ui","icon":"src/assets/images/favicon2025.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"046191919edb4791bdbfdf53a27f2f11"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
